import React from "react"

import { s } from "../../../utilities/common"

export const ErrorIcon = () => {
  return (
    <svg
      width={s("144")}
      height={s("144")}
      viewBox="0 0 144 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.8"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.5294 15H75V6H92.5294C96.9055 6 101.102 7.73839 104.197 10.8327L136.167 42.8033C139.262 45.8976 141 50.0945 141 54.4706V92.5294C141 96.9055 139.262 101.102 136.167 104.197L104.197 136.167C101.102 139.262 96.9055 141 92.5294 141H75V132H92.5294C94.5186 132 96.4262 131.21 97.8327 129.803L129.803 97.8327C131.21 96.4262 132 94.5186 132 92.5294V54.4706C132 52.4814 131.21 50.5738 129.803 49.1673L97.8327 17.1967C96.4262 15.7902 94.5186 15 92.5294 15Z"
        fill="white"
      />
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.4706 132H75V141H51.4706C47.0945 141 42.8977 139.262 39.8033 136.167L7.83275 104.197C4.7384 101.102 3 96.9055 3 92.5294L3 54.4706C3 50.0945 4.73839 45.8977 7.83274 42.8033L39.8033 10.8327C42.8976 7.73839 47.0945 6 51.4706 6H75V15H51.4706C49.4814 15 47.5738 15.7902 46.1673 17.1967L14.1967 49.1673C12.7902 50.5738 12 52.4814 12 54.4706L12 92.5294C12 94.5186 12.7902 96.4262 14.1967 97.8327L46.1673 129.803C47.5738 131.21 49.4814 132 51.4706 132Z"
        fill="white"
      />
      <path
        opacity="0.6"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.3333 102L42.0001 48.6667L48.6667 42L102 95.3333L95.3333 102Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.0001 95.3333L95.3334 42.0001L102 48.6667L48.6668 102L42.0001 95.3333Z"
        fill="white"
      />
    </svg>
  )
}
